// extracted by mini-css-extract-plugin
module.exports = {"modal":"cart-successful-payment_modal__6PDRi","btn":"cart-successful-payment_btn__XPLJo"};